import CreditTransactionListApp from "CreditTransactions/App";
import { type RouteObject } from "react-router";

declare let viewModel: any;

export const creditTransactionRoute: RouteObject = {
  path: "credittransaction",
  children: [{
    index: true,
    loader: () => viewModel as server.viewmodel.CreditTransactionListFrontModel,
    Component: CreditTransactionListApp,
  }]
};
